import { cva } from 'class-variance-authority';

export const cvaRoot = cva([
  'ReviewFormSuccessPopupStyles-cvaRoot',
  'fixed left-0 top-0 z-[200] overflow-auto',
  'w-full h-full',
  'px-[14rem] py-4',
  'text-center',
  'before:h-full before:w-0 before:inline-block before:align-middle',
]);

export const cvaOverlay = cva([
  'ReviewFormSuccessPopupStyles-cvaOverlay',
  'fixed left-0 top-0 ',
  'w-full h-full',
  'bg-cBlack32',
]);

export const cvaClose = cva([
  'ReviewFormSuccessPopupStyles-cvaClose',
  'flex items-center justify-center',
  'absolute top-0 -right-8.8',
  'w-5.6 h-5.6',
  'bg-cWhite',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaCloseIcon = cva(['ReviewFormSuccessPopupStyles-cvaCloseIcon', 'w-1.6 h-1.6', 'fill-cBlack']);

export const cvaInner = cva([
  'ReviewFormSuccessPopupStyles-cvaInner',
  'inline-block align-middle',
  'relative',
  'w-full max-w-[56rem]',
  'p-4.8',
  'bg-cWhite',
  'text-center',
  'rounded-[3.2rem]',
]);

export const cvaEmoji = cva([
  'ReviewFormSuccessPopupStyles-cvaEmoji',
  'relative',
  'w-[10.7rem] h-[10rem]',
  'mx-auto mb-2.4',
]);

export const cvaEmojiImage = cva(['ReviewFormSuccessPopupStyles-cvaEmojiImage', 'object-contain object-center']);

export const cvaTitle = cva(['ReviewFormSuccessPopupStyles-cvaTitle', 'mb-2.4', 'text-h3 font-secondary']);

export const cvaDescr = cva([
  'ReviewFormSuccessPopupStyles-cvaDescr',
  'max-w-[40rem]',
  'mx-auto mb-2.4',
  'text-bodyM text-cBlack64',
]);

export const cvaButton = cva(['ReviewFormSuccessPopupStyles-cvaButton', 'px-3.2 font-semibold']);
